import { Handle, type NodeProps } from "@xyflow/react";
import type { ComparisonNodeData } from "@/types/decision-graph";
import {
  getDualHandleOffsetStyle,
  getHandlePositions,
} from "../utils/handle-positions";

export function ComparisonNode({ data }: NodeProps) {
  const d = data as ComparisonNodeData;
  const { isHorizontal, inputPosition, outputPosition } = getHandlePositions(
    d.layoutDirection
  );

  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs shadow-sm min-w-[80px]">
      <Handle
        type="target"
        position={inputPosition}
        id="left"
        style={getDualHandleOffsetStyle(isHorizontal, "first")}
      />
      <Handle
        type="target"
        position={inputPosition}
        id="right"
        style={getDualHandleOffsetStyle(isHorizontal, "second")}
      />
      <div className="font-medium text-amber-700 text-[10px] mb-0.5">
        COMPARE
      </div>
      <div className="text-amber-900 font-mono text-center text-sm font-bold">
        {d.operator}
      </div>
      <Handle type="source" position={outputPosition} id="result" />
    </div>
  );
}
